import React from 'react';
import PropTypes from 'prop-types';
import { withTitle } from '../../HOC';
import { useBannerInsertion } from '../../hooks';
const TextBlockRender = ({
  parsedTextBlock,
  name
}) => {
  const updatedBlock = useBannerInsertion({
    name,
    parsedTextBlock
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, " ", updatedBlock, " ");
};
TextBlockRender.propTypes = {
  parsedTextBlock: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  name: PropTypes.string.isRequired
};
export default withTitle(TextBlockRender);
//# sourceMappingURL=TextBlockRender.js.map